import { IconLayer } from "@deck.gl/layers";

export function getPlacesLayer(places) {
  const iconLayerProps = {
    id: "icon-layer",
    data: places || [],
    pickable: false,
    getIcon: (place) => {
      return {
        url: place.icon,
        width: 128,
        height: 128,
      };
    },
    // icon size is based on data point's contributions, between 2 - 25
    getSize: 32,
    getPosition: (place) => [
      place.geometry.location.lng(),
      place.geometry.location.lat(),
    ],
    onHover: () => {
      return true;
    },
  };
  return new IconLayer(iconLayerProps);
}
